import { render, staticRenderFns } from "./popUpChange.vue?vue&type=template&id=e98a512a&scoped=true"
import script from "./popUpChange.vue?vue&type=script&lang=js"
export * from "./popUpChange.vue?vue&type=script&lang=js"
import style0 from "./popUpChange.vue?vue&type=style&index=0&id=e98a512a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98a512a",
  null
  
)

export default component.exports